/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';

// ours
import { FieldControl, GlyphLinkOut, Label } from '@americanexpress/dls-react';
import Anchor from '../atomic/atoms/anchor/Anchor';
import BWCurrencyInput from 'src/bw/bw-currency-input/BW-Currency-Input';
import FormatService from '../../services/format.service';
import LiteralsService from '../../services/literals/LiteralsService';

// styles
import styles from './SavingsPerMonth.module.scss';
import { DLSSize } from 'src/types/dls-size.enum';
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';
import Selectors from 'src/utils/selectors';

interface SavingsPerMonthProps {
    delta: number;
    surplus: number;
    inputLabel: string;
    inputValue: number;
    inputOnChange: (value: number) => void;
    status?: JSX.Element;
}

export default function SavingsPerMonth(props: SavingsPerMonthProps): JSX.Element {
    return (
        <div className="drawerSection">
            <Typography variant={TypographyVariants.HEADING_XS} className={styles.perMonthHeader}>
                {LiteralsService.getLiteral('SavingsDrawer.savePerMonth')}
            </Typography>
            <Typography variant={TypographyVariants.BODY}>
                {LiteralsService.getLiteral('SavingsDrawer.perMonthNeeded', [
                    FormatService.format(props.delta),
                    FormatService.format(Math.max(props.surplus, 0))
                ])}
            </Typography>
            <Anchor className={styles.learnAboutLink} data-cy={Selectors.PlanAhead.LEARN_ABOUT_LINK} href="#">
                <Typography variant={TypographyVariants.BODY} className={styles.text}>
                    {LiteralsService.getLiteral('SavingsDrawer.learnAbout')}
                </Typography>
                <GlyphLinkOut className={styles.linkOut} size={DLSSize.LARGE} />
            </Anchor>
            <FieldControl>
                <Label htmlFor="monthlyCurrencyInput">{props.inputLabel}</Label>
                <BWCurrencyInput
                    id="monthlyCurrencyInput"
                    fullWidth
                    defaultValue={0}
                    status=""
                    value={props.inputValue}
                    showFractions={false}
                    onChange={props.inputOnChange}
                    data-cy={Selectors.PlanAhead.SAVINGS_AMOUNT_INPUT}
                />
            </FieldControl>
            {props.status}
        </div>
    );
}
